(ns journal-app-client.connection
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [ajax.core :refer [json-request-format json-response-format]]))

(defonce network-connection js/window.navigator.connection)
(defonce downlink-max
  (atom 
    (when network-connection
      (or network-connection.downlinkMax network-connection.downlink))))
(defonce information
  (r/atom
    (merge
      (when network-connection
        {:effective-type network-connection.effectiveType
         :type           network-connection.type
         :downlink       network-connection.downlink
         :downlink-max   @downlink-max
         :save-data      network-connection.saveData
         :rtt            network-connection.rtt})
      {:online js/window.navigator.onLine})))


(rf/reg-event-fx :check-connection
  (fn [_ [_ _]]
    {:fx [[:http-xhrio {:method :get
                        :headers {:Cache-Control "no-cache"}
                        :uri "https://pokeapi.co/api/v2/pokemon/pikachu" ;; TODO: Request some other endpoint to check net
                        :format (json-request-format)
                        :response-format (json-response-format)
                        :timeout 15000
                        :on-success [:check-connection-success]
                        :on-failure [:check-connection-failure]}]]}))

(rf/reg-event-fx :check-connection-success
  (fn [_ [_ _]]
    (swap! information assoc :online true)))

(rf/reg-event-fx :check-connection-failure
  (fn [_ [_ _]]
    (swap! information assoc :online false)))

(defn update-information []
  (let [new-connection-information (merge
                                     (when network-connection
                                       (let [downlink (when network-connection network-connection.downlink)
                                             new-downlink-max (when network-connection
                                                                (if-let [network-downlink-max network-connection.downlinkMax]
                                                                  (do (reset! downlink-max network-downlink-max)
                                                                      network-downlink-max)
                                                                  (if (>= downlink @downlink-max)
                                                                    (do (reset! downlink-max downlink)
                                                                        downlink)
                                                                    @downlink-max)))]
                                         {:effective-type network-connection.effectiveType
                                          :type           network-connection.type
                                          :downlink       downlink
                                          :downlink-max   new-downlink-max
                                          :save-data      network-connection.saveData
                                          :rtt            network-connection.rtt}))
                                     {:online         js/window.navigator.onLine})]
    (reset! information new-connection-information)
    ;; Need to check that we are actually online because virtual networks can fool the browser. False is always correct,
    ;; but true can be a false positive
    (when (:online new-connection-information)
      ;; The responses are cached by the service worker. So unless we disable caching, it will return success if
      ;; the request was successful the first time it ran
      (rf/dispatch [:check-connection]))))

(defn add-listeners []
  (when network-connection
    (set! network-connection.onchange update-information))
  (js/window.addEventListener "offline" update-information)
  (js/window.addEventListener "online" update-information))